const addParentToChildren = data => {
  const linkToParent = parent => {
    var _parent$items;
    return (_parent$items = parent.items) === null || _parent$items === void 0 ? void 0 : _parent$items.forEach(child => {
      child._parent = parent;
      child.items && linkToParent(child);
    });
  };
  data.forEach(entry => linkToParent(entry));
  return data;
};

export { addParentToChildren };
